export const AUTOMATED_JOIN = {
  SAVE_JOIN: 'AUTOMATED_JOIN/SAVE_JOIN',
  SAVE_JOIN_SUCCESS: 'AUTOMATED_JOIN/SAVE_JOIN_SUCCESS',
  SAVE_JOIN_ERROR: 'AUTOMATED_JOIN/SAVE_JOIN_ERROR',
  FETCH_JOIN: 'AUTOMATED_JOIN/FETCH_JOIN',
  FETCH_JOIN_SUCCESS: 'AUTOMATED_JOIN/FETCH_JOIN_SUCCESS',
  FETCH_JOIN_ERROR: 'AUTOMATED_JOIN/FETCH_JOIN_ERROR',
  RESET: 'AUTOMATED_JOIN/RESET',
};
